export const LIST_ROLE_CAN_FILTER_ACCOUNT_FOR_REPORT = Object.freeze([
  'Admin',
  'FO-Supervisor',
  'FO-Head',
  'Inves-Chairman',
  'Acc-All',
  'Acc-Staff',
  'LS-CFO',
  'Inves-CFO',
  'Acc-Head',
  'Sale-Head',
  'Sale-Supervisor'
])
